export default __webpack_public_path__ + "static/media/image-board-study-pattern-n-w.4eaf23fa.png";